package components.menus.sidebar

import api.ApiService
import csstype.*
import emotion.css.css
import kotlinx.css.img
import mui.material.*
import mui.system.sx
import react.FC
import react.dom.aria.AriaRole
import react.dom.html.ReactHTML
import react.router.useNavigate
import styled.css
import theme.ImageRefs

val Sidebar = FC<SidebarProps> { props ->
    val navigate = useNavigate()

    Drawer {
        id = "sidebar-drawer"
        container = props.container
        anchor = DrawerAnchor.left
        open = props.showSidebar
        variant = DrawerVariant.persistent

        sx {
            flexShrink = number(0.0)
        }

        Box {
            sx {
                width = 300.px
                height = 100.pct
                scrollbarWidth = None.none
            }

            Paper {
                sx {
                    height = 100.pct
                    width = 300.px
                    scrollbarWidth = None.none
                }


                Avatar {
                    variant = AvatarVariant.square
                    alt = "logo"
                    src = ImageRefs.logoRefLightMode

                    sx {
                        width = 190.px
                        height = 130.px
                        marginLeft = Auto.auto
                        marginRight = Auto.auto
                        marginBottom = 20.px

                        ReactHTML.img {
                            objectFit = ObjectFit.contain
                        }
                    }
                }

                List {
                    MenuItemMapping.forEach { menuItem ->
                        if (menuItem.element != null) {
                            + menuItem.element
                        } else {
                            ListItem {
                                ListItemButton {
                                    onClick = {
                                        if (!menuItem.href.isNullOrEmpty()) navigate(menuItem.href)
                                        if (menuItem.logout) {
                                            ApiService.logout(props.sessionSetter)
                                            navigate("/")
                                        }
                                    }

                                    ListItemIcon {
                                        menuItem.icon()
                                    }

                                    ListItemText {
                                        + menuItem.title
                                    }
                                }
                            }
                        }
                    }
                }
            }


        }
    }
}